import { initReportsState } from 'redux/initial.state';
import produce from 'immer';
import { ReportsState } from 'types/redux/state/reports.state';
import { setLoadable } from 'utils/state.handlers';
import { ReportsAction, ReportActions } from 'types/redux/actions/reports.action';

export const reportsReducer = (
  state = initReportsState(),
  action: ReportsAction,
): ReportsState =>
  produce(state, (clone) => {
    switch (action.type) {
      case ReportActions.FETCH_REPORTS:
        setLoadable(clone, action.isLoading, action.error);
        break;

      case ReportActions.FETCH_REPORTS_SUCCESS:
        setLoadable(clone, false, undefined);
        clone.reports = {
          ...clone.reports,
          reports: action.reports.reports,
          meta: action.reports.meta,
        };
        break;

      case ReportActions.FETCH_REPORTS_FAILURE:
        setLoadable(clone, false, action.error);
        clone.error = action.error;
        break;

      case ReportActions.UPDATE_REPORT:
        setLoadable(clone, action.isLoading, action.error);
        break;

      case ReportActions.UPDATE_REPORT_SUCCESS:
        setLoadable(clone, false, undefined);
        clone.message = action.message;
        break;

      case ReportActions.COMPARE_REPORTS:
        setLoadable(clone, action.isLoading, action.error);
        break;

      case ReportActions.COMPARE_REPORTS_SUCCESS:
        setLoadable(clone, false, undefined);
        clone.comparedReports = action.comparedReports;
        break;

      case ReportActions.COMPARE_REPORTS_FAILURE:
        setLoadable(clone, false, action.error);
        clone.error = action.error;
        break;
    }
  });
